import React, { useCallback, useState } from 'react';
import Image from 'js/components/common/Image';
import { useTranslations } from 'js/hooks/i18n';
import { path, prop } from 'js/utils/ramda.util';
import { useLaunchGame } from 'js/hooks/gameLauncher';
import { useAppSelector, useUserSelector } from 'js/store/hooks';
import { AccessibilityElement } from 'js/components/common/AccessibilityElement';

import emptyGameImage from './images/Game_placeholder.svg';

import style from './Game.scss';

export const Game = (props) => {
    const launchGame = useLaunchGame();
    const translate = useTranslations();
    const { code, className = '', setGameRef } = props;
    const game = useAppSelector(path(['games', code]));
    const isLoggedIn = useUserSelector(prop('isLoggedIn'));
    const { images = {}, name } = game;
    const [src, setSrc] = useState(!isLoggedIn && images.guest || images.base);

    const onClick = useCallback(() => launchGame({ code, mode: 1 }), [code, launchGame]);

    const onError = useCallback(() => {
        setSrc(emptyGameImage);
    }, [setSrc]);

    if (!game) {
        return null;
    }

    return (
        <AccessibilityElement
            title={name}
            onClick={onClick}
            data-game-code={code}
            elementRef={setGameRef}
            className={`${style.container} ${className}`}
            aria-label={`${translate('playtech.mobile.system.game.aria-label')} ${name}`}
        >
            <div className={style.imageContainer} >
                <Image
                    src={src}
                    alt={name}
                    onError={onError}
                    className={`${style.image} ${src !== emptyGameImage ? '' : style.emptyGame}`}
                />
            </div>
            <div className={style.titleWrapper}>
                <span className={style.name}>{name}</span>
            </div>
        </AccessibilityElement>
    );
};
